import wplywyGetList from "./wplywyGetList";
const data = () => {
    return wplywyGetList();  
};
export default data;